import styled from "styled-components";
import { H3, IconButton } from "@evergis/ui";

export const DropdownOption = styled.span<{ mute?: boolean }>`
  opacity: ${({ mute }) => mute && 0.28};
`;

export const ModalMain = styled.div`
  padding: 0 3rem;
  background-color: ${({ theme: { palette } }) => palette.element};
  flex: 1;
`;

export const SelectLayersTitle = styled(H3)`
  margin-bottom: 0.25rem;
`;

export const SelectLayersDescription = styled.div`
  margin-top: 0;
`;

export const AddLayerButton = styled(IconButton)`
  margin-top: 1.5rem;
`;
